import React from 'react';
import uuid from 'uuid';
import { fetchApi } from '@marvelapp/core';
import { Box, Button, Flex, Heading, Image, Text, TwinColumn, } from '@marvelapp/ui';
import Link from '../Link';
import { showErrorNotification } from '../ToastContainer';
import image from './image.png';
import image2x from './image@2x.png';
export default function LimitMessage({ userType, goToSuccessScreen, isSendingSubmission, postData, setIsSendingSubmission, }) {
    return (React.createElement(TwinColumn, { padding: true },
        React.createElement(Flex, { alignItems: "center", display: "flex", flexDirection: "column", height: "100%", justifyContent: "center" },
            React.createElement(Image, { alt: "Planting seeds illustration", display: "block", src: image, src2x: image2x })),
        React.createElement(Flex, { alignItems: "center", flexDirection: "column", height: "100%", justifyContent: "center" },
            React.createElement(Box, { maxWidth: 380 },
                React.createElement(Heading, { fontSize: 7 }, "Contact us to add more seats"),
                React.createElement(Text, { fontSize: 4, mt: 2 },
                    "You",
                    "'",
                    "ve reached the maximum amount of ",
                    userType,
                    " on your plan. Speak to us about upgrading to Marvel Enterprise"),
                React.createElement(Button, { isLoading: isSendingSubmission, kind: "marvel", mt: 4, onClick: () => {
                        setIsSendingSubmission(true);
                        sendEnterpriseRequest({
                            goToSuccessScreen,
                            postData,
                            setIsSendingSubmission,
                        });
                    }, size: 3 }, "Request more info")))));
}
function sendEnterpriseRequest({ goToSuccessScreen, postData, setIsSendingSubmission, }) {
    const formData = postData;
    formData.form_uuid = uuid.v4();
    fetchApi('/api/enterprise/send/', {
        method: 'POST',
        body: JSON.stringify(formData),
        headers: { 'content-type': 'application/json' },
    })
        .then(goToSuccessScreen)
        .catch(() => {
        showErrorNotification({
            content: (React.createElement(React.Fragment, null,
                "There was an issue processing the request. Please contact support at",
                ' ',
                React.createElement(Link, { color: "marvel", to: "mailto:help@marvelapp.com" }, "help@marvelapp.com"),
                ' ',
                "if the issue persists")),
        });
    })
        .finally(() => setIsSendingSubmission(false));
}
